/* Only style the newsletter. Shopify owns the fields, submission and discount. */
const selector = 'shopify-forms-embed#app-embed-container-1158098';
const rules = `
  #app-embed h2 { line-height: 1.12; letter-spacing: -.025em; text-wrap: balance; }
  #app-embed [role="dialog"] p { line-height: 1.45; }
  #app-embed form + div p { font-size: 14px; color: #48453f; }
  #app-embed [data-testid="btn-form-submit"] {
    background: var(--hp-glass-smoke, #23221f);
    box-shadow: var(--hp-glass-dark-rim);
    color: #fff;
    font-weight: 650;
    box-sizing: border-box;
    display: grid;
    place-items: center;
    min-height: 50px;
  }
  #app-embed [data-testid="form-teaser"] {
    background: var(--hp-glass-clear, #f6f3ec);
    box-shadow: var(--hp-glass-rim);
    border-radius: 20px;
  }
  #app-embed [data-testid="form-teaser"] h3 { line-height: 1.22; }

  /* The whole coupon is Shopify's original copy button. */
  #app-embed [data-testid="banner-success"] {
    --coupon-caption: "Rabattcode";
    --coupon-action: "Kopieren";
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    grid-template-areas: "title" "terms" "coupon";
    align-items: start;
    text-align: start;
    gap: 10px;
    margin: 0;
  }
  :host(:lang(en)) #app-embed [data-testid="banner-success"] {
    --coupon-caption: "Discount code";
    --coupon-action: "Copy";
  }
  #app-embed [data-testid="banner-success"] > h2 {
    grid-area: title;
    display: block;
    margin: 0;
    padding-inline-end: 20px;
    font: var(--forms-heading-font);
    line-height: 1.08;
  }
  #app-embed [data-testid="banner-success"] > div {
    grid-area: terms;
    font: var(--forms-body-font);
  }
  #app-embed [data-testid="banner-success"] > button {
    grid-area: coupon;
    box-sizing: border-box;
    width: 100%;
    display: grid;
    grid-template: "caption action" auto "code action" auto / minmax(0, 1fr) max-content;
    align-items: center;
    gap: 6px 14px;
    margin: 9px 0 0;
    padding: 18px;
    text-align: start;
    border: 1px dashed #a29a8f;
    border-radius: 16px;
    background: #fffcf7;
    box-shadow: inset 0 1px 0 #fff;
    color: #211f1c;
    cursor: pointer;
  }
  #app-embed [data-testid="banner-success"] > button::before {
    grid-area: caption;
    content: var(--coupon-caption);
    font: 650 12px/1.2 var(--font-paragraph--family, Inter, sans-serif);
    letter-spacing: .08em;
    text-transform: uppercase;
    color: #59534c;
  }
  #app-embed [data-testid="banner-success"] > button > span {
    grid-area: code;
    min-width: 0;
    font: 650 clamp(19px, 3vw, 24px)/1.25 ui-monospace, "SFMono-Regular", Consolas, monospace;
    letter-spacing: .025em;
    color: #171614;
    white-space: normal;
    overflow-wrap: anywhere;
    overflow: visible;
  }
  #app-embed [data-testid="banner-success"] > button::after {
    grid-area: action;
    content: var(--coupon-action);
    display: grid;
    place-items: center;
    min-height: 44px;
    padding-inline: 36px 15px;
    border-radius: 999px;
    background: var(--hp-glass-smoke, #242321);
    box-shadow: var(--hp-glass-dark-rim);
    color: #fff;
    font: 650 14px/1.2 var(--font-paragraph--family, Inter, sans-serif);
  }
  #app-embed [data-testid="banner-success"] > button > svg {
    grid-area: action;
    justify-self: start;
    width: 15px;
    height: 15px;
    z-index: 1;
    margin: 0;
    margin-inline-start: 13px;
    --forms-discount-code-color: #fff;
    color: #fff;
    pointer-events: none;
  }
  #app-embed [data-testid="banner-success"] > button:focus-visible {
    outline: 2px solid #282521;
    outline-offset: 3px;
  }
  @media (hover: hover) {
    #app-embed [data-testid="banner-success"] > button:hover { border-color: #514b43; }
  }
  @media (max-width: 410px) {
    #app-embed [data-testid="banner-success"] > button {
      grid-template: "caption" auto "code" auto "action" auto / minmax(0, 1fr);
      padding: 15px;
    }
    #app-embed [data-testid="banner-success"] > button::after {
      justify-self: start;
      margin-top: 5px;
    }
    #app-embed [data-testid="banner-success"] > button > svg { margin-block-start: 5px; }
  }
  @media (forced-colors: active) {
    #app-embed [data-testid="banner-success"] > button::after {
      border: 1px solid ButtonText;
      color: ButtonText;
      background: ButtonFace;
    }
    #app-embed [data-testid="banner-success"] > button > svg { --forms-discount-code-color: ButtonText; }
  }
  @media (max-height: 540px) {
    #app-embed [role="dialog"][aria-label] { overflow-y: auto; max-height: 90dvh; }
  }
  @media (forced-colors: active) {
    #app-embed :is([data-testid="btn-form-submit"], [data-testid="form-teaser"]) {
      background: ButtonFace; color: ButtonText; border: 1px solid ButtonText;
    }
  }
  @media (max-width: 749px) {
    #app-embed[data-current-step="tease"] {
      left: 16px !important;
      right: auto !important;
      bottom: calc(84px + env(safe-area-inset-bottom, 0px)) !important;
      padding: 0 !important;
      max-width: calc(100vw - 32px);
      visibility: var(--hp-teaser-visibility, visible);
      pointer-events: var(--hp-teaser-pointer-events, auto);
    }
    #app-embed [data-testid="form-teaser"] {
      box-sizing: border-box;
      width: min(260px, calc(100vw - 32px));
      max-width: calc(100vw - 32px);
      margin: 0;
      padding: 14px 16px;
      gap: 14px;
    }
    #app-embed [data-testid="form-teaser"] h3 {
      font-size: 18px;
      line-height: 1.2;
      text-align: left;
    }
  }

`;

function styleForm(host) {
  const root = host?.shadowRoot;
  if (!root || root.querySelector('style[data-hp-newsletter]')) return;
  const style = document.createElement('style');
  style.dataset.hpNewsletter = '';
  style.textContent = rules;
  root.append(style);
}

// The popup mounts asynchronously as a direct child of body.
const observer = new MutationObserver(records => {
  for (const record of records) {
    for (const node of record.addedNodes) {
      if (node.nodeType === 1 && node.matches(selector)) {
        requestAnimationFrame(() => styleForm(node));
      }
    }
  }
});
observer.observe(document.body, { childList: true });
styleForm(document.querySelector(selector));
